import { bodyBgRepeat } from './BodyBgStore.js';

export const updateBodyBgRepeat = (value) => bodyBgRepeat.update(oldValue => value);
